const rawDataQc = {
  title: "Raw Data QC Documentation",

  fields: [
    {
      title: "Project Name",

      description:
        "Provide a meaningful and unique name for your Raw Data Quality Control project. This name is used to identify the analysis throughout the platform.",

      examples: [
        "RNASeq_QC",
        "Sample_QC_Run01",
        "WholeGenome_QC",
      ],

      notes: [
        "Choose a descriptive project name.",
        "Avoid unnecessary special characters.",
        "The project name will appear in your dashboard and reports.",
      ],
    },

    {
      title: "Number of Samples",

      description:
        "Specify the total number of sequencing samples included in the quality control analysis. Credits are calculated automatically based on this value.",

      examples: [
        "1",
        "10",
        "50",
      ],

      notes: [
        "Must be greater than zero.",
        "Ensure the number matches the uploaded sequencing samples.",
      ],
    },

    {
      title: "Short Notes",

      description:
        "Provide any additional information or special instructions for your sequencing data that may help during analysis.",

      examples: [
        "Illumina paired-end sequencing.",
        "Human RNA sequencing dataset.",
      ],

      notes: [
        "Optional field.",
        "Can be used to provide additional context for the analysis team.",
      ],
    },

    {
      title: "Raw Data Source",

      description:
        "Specify how the sequencing data will be provided for quality control analysis.",

      examples: [
        "Online",
        "Offline",
      ],

      notes: [
        "For Online, provide the download link to your sequencing files.",
        "Username and password may be supplied if authentication is required.",
        "For Offline submissions, our team will contact you regarding data transfer.",
      ],
    },

    {
      title: "Metadata Builder",

      description:
        "Provide a unique Sample ID for each sequencing sample included in the analysis. Sample IDs are used throughout the quality control workflow and final reports.",

      examples: [
        "Sample_001",
        "Control_01",
        "Patient_A01",
      ],

      notes: [
        "At least one Sample ID is required.",
        "Each Sample ID must be unique.",
        "Click 'Add Sample' to add additional samples.",
        "Click 'Save Metadata' after completing all Sample IDs.",
        "Use 'Modify Metadata' to edit the metadata later if required.",
      ],
    },

    {
      title: "Perform Raw Data Filtering",

      description:
        "Enable this option to filter low-quality reads before generating the quality control report.",

      notes: [
        "Recommended for most sequencing datasets.",
        "Low-quality reads and bases are removed according to the selected quality parameters.",
        "If disabled, only quality assessment is performed without modifying the sequencing reads.",
      ],
    },

    {
      title: "Raw Data QC Parameters",

      description:
        "Configure the quality control thresholds used to evaluate and optionally filter sequencing reads.",

      sections: [
        {
          title: "Phred Quality Score",

          description:
            "Defines the minimum acceptable base quality score during quality filtering.",

          notes: [
            "Allowed range: 10–40.",
            "Default value: 30.",
            "Higher values perform stricter quality filtering.",
          ],
        },

        {
          title: "Minimum Read Length Required",

          description:
            "Specifies the minimum read length remaining after trimming for a read to be retained.",

          notes: [
            "Allowed range: 50–120 bases.",
            "Default value: 75 bases.",
            "Reads shorter than this value are discarded.",
          ],
        },
      ],
    },

    {
      title: "Analysis Workflow",

      description:
        "The Raw Data QC pipeline evaluates sequencing quality and optionally filters low-quality reads before downstream analysis.",

      sections: [
        {
          title: "Pipeline",

          description:
            "Input Validation → Quality Assessment → Adapter & Quality Trimming (Optional) → Read Length Filtering → QC Report Generation",
        },
      ],
    },
  ],
};

export default rawDataQc;